const TokenKey = 'vue_admin_template_token'
const UserInfoKey = 'vue_admin_template_UserInfo'
export function getInfo() {
	let userInfo = JSON.parse(sessionStorage.getItem(UserInfoKey));
  return userInfo
}

export function getToken() {
  // return localStorage.getItem(TokenKey)
  return sessionStorage.getItem(TokenKey)
}

export function setToken(token) {
  // return localStorage.setItem(TokenKey, token)
  return sessionStorage.setItem(TokenKey, token)
}
export function setUserInfo(userInfo) {
  // return localStorage.setItem(UserInfoKey, userInfo)
  return sessionStorage.setItem(UserInfoKey, userInfo)
}